import React, { createContext, useReducer } from 'react'
import peer from 'peerjs'

type Peer = {
	init?: boolean
	id?: string
	peer?: peer
}

type State = {
	connected: boolean
	local: Peer
	remote: { id: string }
}

type Actions =
	| { type: 'update_status'; payload: boolean }
	| { type: 'update_local'; payload: Peer }
	| { type: 'update_remote'; payload: { id: string } }

const initialState: State = { connected: false, local: null, remote: null }

const reducer = (state: State, action: Actions) => {
	switch (action.type) {
		case 'update_status':
			return { ...state, connected: action.payload }

		case 'update_local':
			return { ...state, local: action.payload }

		case 'update_remote':
			return { ...state, remote: action.payload }

		default:
			return state
	}
}

type Context = { state: State; dispatch: React.Dispatch<Actions> }

const UserContext = createContext<Context>(null)

const UserProvider = ({ children }) => {
	const [state, dispatch] = useReducer(reducer, initialState)

	return (
		<UserContext.Provider value={{ state, dispatch }}>
			{children}
		</UserContext.Provider>
	)
}

export { UserContext, UserProvider }
